// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__37pnS","dragIcon":"Choice_dragIcon__2dpN8","left":"Choice_left__3Gck1","input":"Choice_input__20knt"};